
import React from "react";
import { NavLink } from "react-router-dom";
import "./Header.css";

function Header() {
  return (
    <header className="header">
      <div className="logo">React<span>Site</span></div>
      <nav>
        <NavLink to="/" className="nav-link">Home</NavLink>
        <NavLink to="/about" className="nav-link">About</NavLink>
        <NavLink to="/user-info" className="nav-link">User Info</NavLink>
      </nav>
    </header>
  );
}

export default Header;
